export const ITEM_BOX_LOG_LIST_REQUEST = 'ITEM_BOX_LOG_LIST_REQUEST';

export const ITEM_BOX_LOG_LIST = 'ITEM_BOX_LOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_ITEM_BOX_LOG_PAGINATION = 'SET_ITEM_BOX_LOG_PAGINATION';

export const ITEM_BOX_LOG_PAGE_RESET = 'ITEM_BOX_LOG_PAGE_RESET';
